import { QUESTION_TYPES } from '@api/instant_survey';

export const availableQuestionVariables = [
  'banner',
  'brand',
  'category',
  'channel',
  'date',
  'majorcat',
  'parentbrand',
  'parentchannel',
  'retailer',
  'subcategory',
];

export const newItemAvailableQuestionVariables = ['item_name'];

export const QUESTION_TYPES_HELP_URL =
  'https://help.numerator.com/en/articles/10949983-in-platform-surveys-question-types';

export const DEFAULT_QUESTION_PROPS_BY_TYPE = {
  [QUESTION_TYPES.CHECKBOX.value]: {
    maxAnswers: undefined,
    randomizeOptions: false,
  },
  [QUESTION_TYPES.CONTSUM.value]: {
    forceNumeric: true,
    maxNumber: 100,
    maxTotal: 100,
    minNumber: 0,
    mustBeMax: false,
    onlyWholeNum: false,
  },
  [QUESTION_TYPES.MAX_DIFF.value]: {
    bestLabel: 'Best',
    numberOfSets: 5,
    optionsPerSet: 5,
    worstLabel: 'Worst',
  },
  [QUESTION_TYPES.NUMERIC.value]: {
    forceNumeric: true,
    maxNumber: 100,
    minNumber: 0,
    onlyWholeNum: false,
  },
};

export const NONE_OF_THE_ABOVE = 'None of the above';
export const NONE_OF_THE_ABOVE_EU = 'Keine der genannten';
export const OTHER_PLEASE_SPECIFY = 'Other, please specify';
export const OTHER_PLEASE_SPECIFY_EU = 'Sonstiges, bitte angeben';

export const OTHER_PLEASE_SPECIFY_ALTERNATES = [
  OTHER_PLEASE_SPECIFY.toLowerCase(),
  'other: please specify',
  'other please specify',
  'other (specify)',
];
export const OTHER_PLEASE_SPECIFY_ALTERNATES_EU = [
  OTHER_PLEASE_SPECIFY_EU.toLowerCase(),
  'sonstiges bitte angeben',
];

export const FORMATS = {
  CURRENCY: {
    name: 'Currency',
    value: 'forceCurrency',
  },
  NUMBER: {
    name: 'Number',
    value: 'forceNumeric',
  },
  PERCENT: {
    name: 'Percent',
    value: 'forcePercent',
  },
};

export const ANSWER_MAX_LENGTH = 150;
export const QUESTION_MAX_LENGTH = 1000;

export const QUESTION_CONT_SUM_MAX_OPTIONS = 15;
export const QUESTION_GRID_MAX_COLUMNS = 12;
export const QUESTION_GRID_MAX_ROWS = 12;
export const QUESTION_MAX_DIFF_ANSWER_LENGTH = 75;
export const QUESTION_MAX_DIFF_LABEL_LENGTH = 100;
export const QUESTION_MAX_DIFF_MAX_OPTIONS = 30;
export const QUESTION_MAX_DIFF_MAX_SETS = 15;
export const QUESTION_MAX_DIFF_MIN_OPTIONS = 10;
export const QUESTION_MAX_DIFF_MIN_SETS = 3;
export const QUESTION_RANK_MAX_OPTIONS = 15;
export const QUESTION_TURF_MAX_OPTIONS = 30;

export const VALIDATION_MESSAGES = {
  ANSWER_BLANK_ERROR: 'Answer options cannot be blank.',
  ANSWER_LENGTH_ERROR: `Answer text exceeds the max-length of ${ANSWER_MAX_LENGTH}.`,
  ANSWERS_REQUIRED: 'Answer options are required.',
  CONTSUM_MAX_OPTIONS_ERROR: `${QUESTION_TYPES.CONTSUM.name} questions are limited to ${QUESTION_CONT_SUM_MAX_OPTIONS} options.`,
  GRID_COLUMN_LENGTH_ERROR: `Column exceeds the max-length of ${ANSWER_MAX_LENGTH}.`,
  GRID_COLUMNS_BLANK_ERROR: 'Columns cannot be blank.',
  GRID_COLUMNS_REQUIRED: `${QUESTION_TYPES['TABLE-RADIO'].name} questions require at least 1 column.`,
  GRID_MAX_COLUMNS_ERROR: `${QUESTION_TYPES['TABLE-RADIO'].name} questions are limited to ${QUESTION_GRID_MAX_COLUMNS} columns.`,
  GRID_MAX_ROWS_ERROR: `${QUESTION_TYPES['TABLE-RADIO'].name} questions are limited to ${QUESTION_GRID_MAX_ROWS} rows.`,
  GRID_ROW_LENGTH_ERROR: `Row exceeds the max-length of ${ANSWER_MAX_LENGTH}.`,
  GRID_ROWS_BLANK_ERROR: 'Rows cannot be blank.',
  GRID_ROWS_REQUIRED: `${QUESTION_TYPES['TABLE-RADIO'].name} questions require at least 1 row.`,
  MAX_DIFF_ANSWER_LENGTH_ERROR: `Answer text exceeds the max-length of ${QUESTION_MAX_DIFF_ANSWER_LENGTH}.`,
  MAX_DIFF_BEST_LABEL_LENGTH_ERROR: `Best label exceeds the max-length of ${QUESTION_MAX_DIFF_LABEL_LENGTH}.`,
  MAX_DIFF_BEST_LABEL_REQUIRED: 'Best label is required and cannot be blank.',
  MAX_DIFF_MAX_OPTIONS_ERROR: `${QUESTION_TYPES.MAX_DIFF.name} questions are limited to ${QUESTION_MAX_DIFF_MAX_OPTIONS} options.`,
  MAX_DIFF_MIN_OPTIONS_ERROR: `${QUESTION_TYPES.MAX_DIFF.name} questions must have at least ${QUESTION_MAX_DIFF_MIN_OPTIONS} options.`,
  MAX_DIFF_WORST_LABEL_LENGTH_ERROR: `Worst label exceeds the max-length of ${QUESTION_MAX_DIFF_LABEL_LENGTH}.`,
  MAX_DIFF_WORST_LABEL_REQUIRED: 'Worst label is required and cannot be blank.',
  MAX_PERCENTAGE_ERROR: 'Max percentage cannot be greater than 100.',
  MAX_VALUE_MAX_TOTAL_ERROR: 'Maximum allowed value cannot be greater than max total.',
  NO_NONE_OF_THE_ABOVE: `Can't have none of the above with this question type.`,
  NO_OTHER_PLEASE_SPECIFY: `Can't have a write-in with this question type.`,
  QUESTION_COST_ERROR: 'The question cost exceeds what is available in the survey.',
  QUESTION_MAX_LENGTH_ERROR: `Question text exceeds the max-length of ${QUESTION_MAX_LENGTH}.`,
  QUESTION_TEXT_REQUIRED: 'Question text is required and cannot be blank.',
  RANK_MAX_OPTIONS_ERROR: `${QUESTION_TYPES['RANK-DRAGDROP'].name} questions are limited to ${QUESTION_RANK_MAX_OPTIONS} options.`,
  TURF_MAX_OPTIONS_ERROR: `${QUESTION_TYPES.TURF.name} questions are limited to ${QUESTION_TURF_MAX_OPTIONS} options.`,
};
